//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import UserPublicAvatar from '@/components/users/UserPublicAvatar.vue'
import ModalAuth from '../modals/ModalAuth.vue';
import ModalInputNickname from '../modals/ModalInputNickname.vue';
import NewCreateObjectTypeChoice from "./NewCreateObjectTypeChoice.vue";

export default {
  name: 'HeaderUserBlock',
  components: {
    UserPublicAvatar,
    ModalAuth,
    ModalInputNickname,
    NewCreateObjectTypeChoice,
  },
  props: {
    withoutCreateObject: Boolean
  },
  data() {
    return {
      isMounted: false,
      openCreateModal: false,
    }
  },
  computed: {
    userName() {
      return this.$auth.user.profile.nickname ?? this.$auth.user.username
    },
    showAvailable() {
      return ['A', 'CA', 'CE'].includes(this.$auth.user.role)
    },
    openedAuthModal() {
      return this.isMounted && this.$store.getters['auth_modals/getAuthModal']
    },
    openedInputNicknameModal() {
      return this.isMounted && this.$store.getters['auth_modals/getNicknameModal']
    },
  },
  mounted() {
    this.isMounted = true
  },
  destroyed() {
    this.isMounted = false
  },
  methods: {
    async logoutClickHandler() {
      await this.$auth.logout()
      this.$router.push({ path: '/' })
    },
    openObjectTypeChoice() {
      this.openCreateModal = true
      this.$nextTick(() => {
        if (this.$refs.typeChoice && this.$refs.typeChoice.show) {
          this.$refs.typeChoice.show()
        }
      })
    },
    closeObjectTypeChoice() {
      if (this.$refs.typeChoice && this.$refs.typeChoice.hide) {
        this.$refs.typeChoice.hide()
      }
      this.openCreateModal = false
    },
    closeAuthModal() {
      this.$store.dispatch('auth_modals/showAuthModal', false)
    },
    closeInputNicknameModal() {
      this.$store.dispatch('auth_modals/showNicknameModal', false)
    },
    openAuthModal() {
      this.$store.dispatch('auth_modals/showAuthModal', true)
    },
  },
}
